import { render, staticRenderFns } from "./comp_CategoriesMegaMenu.vue?vue&type=template&id=450bf622&scoped=true&"
import script from "./comp_CategoriesMegaMenu.vue?vue&type=script&lang=js&"
export * from "./comp_CategoriesMegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./comp_CategoriesMegaMenu.vue?vue&type=style&index=0&id=450bf622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450bf622",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
